import Vue from "vue";
// import iview from "view-design";
import viewDesign from "view-design";
import moment from 'moment';
import momenttimezone from 'moment-timezone';

import { typeOf } from '@mods/utils/tools';
import Dates from '@mods/utils/date';


// import "iview/dist/styles/iview.css";
import "./style/index.scss";
import 'view-design/dist/styles/iview.css';


Vue.use(viewDesign);

Vue.prototype.$moment = moment
Vue.prototype.$momenttimezone = momenttimezone



export default {
    filters: {
        transferText(val = '', text = "", list = [], key = "id") {
            if (val === '' || !list) return '';
            let type = typeOf(list), data = {}
            if (type === 'array') {
                data = list.filter(item => {
                    return item[key] == val;
                })[0] || {};
            } else if (type === 'object') {
                data = list;
            }
            if (text.indexOf('%') == -1) return data[text];//兼容老模块

            return text.replace(/\%([A-Za-z0-9_-]+)\%/g, function (match, reg, index, str) {
                return data[reg] || ''
            })
        }
    },
    methods: {
        handleDateFormat(date, format) {
            return Dates.stringify(date, format);
        },
    },
}